import { h } from 'preact';
import * as preactRouter from 'preact-router';

import { PUBLIC_FOLDER } from '../../consts.js';

export function PharosLink(props) {
  const { href, ...otherProps } = props;
  return h(preactRouter.Link, {
    ...otherProps,
    href: `${PUBLIC_FOLDER}${href}`,
  });
}
